import { get, post, put, deletefn } from "../api/require";

// 用户基本信息
export function loginAffirm(params) {
    return post(`/v1/front/ologin`, params)
}

export function getsettingrechargePay(params) {
    return get(`/v1/front/setting/recharge`, params)
}

export function postZfb(params) {
    return post(`/v1/front/hfive/order/zfb`, params)
}
